import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import { asyncComponent } from '@jaredpalmer/after';

const Cart = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-cart-chunk" */
      '../containers/Shop/Cart'
    ),
  chunkName: 'shop-cart-chunk',
  Placeholder: () => <></>
});
const OrderPage = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-orderpage-chunk" */
      '../containers/Shop/OrderPage'
    ),
  chunkName: 'shop-orderpage-chunk',
  Placeholder: () => <></>
});
const Payment = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-payment-chunk" */
      '../containers/Shop/Payment'
    ),
  chunkName: 'shop-payment-chunk',
  Placeholder: () => <></>
});
const ShopConfirmation = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-confirmation-chunk" */
      '../containers/Shop/ShopConfirmation'
    ),
  chunkName: 'shop-confirmation-chunk',
  Placeholder: () => <></>
});
const SingleProduct = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-singleproduct-chunk" */
      '../containers/Shop/SingleProduct'
    ),
  chunkName: 'shop-singleproduct-chunk',
  Placeholder: () => <></>
});
const Products = asyncComponent({
  loader: () =>
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "shop-products-chunk" */
      '../containers/Shop/Products'
    ),
  chunkName: 'shop-products-chunk',
  Placeholder: () => <></>
});

class Shop extends Component {
  render() {
    const { match } = this.props;
    return (
      <div>
        <Helmet title="Kauppa - Kuluttaja" />
        <Switch>
          <Route
            path={`${match.url}/ostoskori`}
            children={({ location }) => <Cart location={location} />}
          />
          <Route
            path={`${match.url}/tilaajan-tiedot`}
            children={({ location }) => <OrderPage location={location} />}
          />
          <Route
            path={`${match.url}/maksu`}
            children={({ location }) => <Payment location={location} />}
          />
          <Route
            path={`${match.url}/vahvistus`}
            children={({ location }) => (
              <ShopConfirmation location={location} />
            )}
          />
          <Route
            path={`${match.url}/tuote/:productSlug`}
            children={({ match, location }) => (
              <SingleProduct match={match} location={location} />
            )}
          />
          <Route
            children={({ location }) => <Products location={location} />}
          />
        </Switch>
      </div>
    );
  }
}

export default Shop;
